import { Link } from "react-router-dom";
import { siteIntro } from "@/mocks/site";
import { useSeo } from "@/hooks/useSeo";

export default function About() {
  useSeo(
    "关于我们 - 榴莲视频",
    "了解榴莲视频：一个综合性影视资源在线观看与影视资讯平台，专注为影视爱好者提供最新电影、电视剧、综艺内容与专业资讯。",
    "榴莲视频,关于我们,影视平台,免责声明,影视资讯",
  );

  const values = [
    {
      icon: "ri-flashlight-line",
      title: "更快的发现",
      desc: "首页焦点、分类榜单与最新推荐同步更新，帮你第一时间找到值得看的作品。",
    },
    {
      icon: "ri-shield-star-line",
      title: "更真的视角",
      desc: "资讯频道坚持专业与克制的表达，从行业动态到幕后故事，提供有信息量的阅读。",
    },
    {
      icon: "ri-heart-3-line",
      title: "更舒服的浏览",
      desc: "沉浸式深色视觉与清晰的层级结构，兼顾桌面与手机，长时间浏览也不易疲劳。",
    },
  ];

  return (
    <>
      <section className="relative overflow-hidden border-b border-background-200/60">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=immersive%20dark%20cinema%20lounge%20with%20glowing%20screens%20and%20warm%20amber%20accent%20lighting%2C%20deep%20purple%20ambience%2C%20premium%20modern%20atmosphere&width=1600&height=600&seq=ld-about-hero&orientation=landscape"
            alt="关于榴莲视频"
            title="关于榴莲视频"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/50"></div>
        </div>
        <div className="relative mx-auto max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
          <nav className="mb-4 flex items-center gap-2 text-xs text-foreground-400">
            <Link to="/" className="hover:text-accent-500 cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">关于我们</span>
          </nav>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-900/25 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-leaf-line"></i>
            关于榴莲视频
          </span>
          <h1 className="mt-4 max-w-2xl font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            一个为影视爱好者而生的<span className="text-accent-500">观影与资讯</span>平台
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
            {siteIntro.description}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-film-line"></i>
              开始浏览影视
            </Link>
            <Link
              to="/news"
              className="flex items-center gap-2 rounded-md border border-background-300/70 bg-background-100/50 px-6 py-3 text-sm text-foreground-700 backdrop-blur-sm transition-colors hover:border-primary-400 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-newspaper-line"></i>
              阅读影视资讯
            </Link>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
          {siteIntro.stats.map((s, i) => (
            <div
              key={s.label}
              className={`rounded-lg border border-background-200/60 bg-background-100/40 p-5 text-center animate-fade-up delay-${i + 1} md:p-6`}
            >
              <p className="font-heading text-2xl font-bold text-accent-500 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-400">{s.label}</p>
            </div>
          ))}
        </div>

        <section className="mt-14">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <Link to="/about" className="hover:text-accent-500 cursor-pointer">我们坚持的三件事</Link>
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {values.map((v, i) => (
              <div
                key={v.title}
                className={`rounded-lg border border-background-200/60 bg-background-100/40 p-6 animate-fade-up delay-${i + 1}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500/20 text-accent-500">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <section className="rounded-lg border border-background-200/60 bg-background-100/40 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">
              <Link to="/about" className="hover:text-accent-500 cursor-pointer">联系与反馈</Link>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              如果你发现内容错误、希望推荐作品，或对我们的产品有建议，欢迎随时联系我们。我们珍惜每一条来自影迷的声音。
            </p>
            <div className="mt-5 space-y-3">
              <a
                href={`mailto:${siteIntro.email}`}
                className="flex items-center gap-3 rounded-md bg-primary-500/15 px-4 py-3 text-sm text-primary-800 transition-colors hover:bg-primary-500/25 cursor-pointer"
              >
                <i className="ri-mail-send-line text-lg"></i>
                {siteIntro.email}
              </a>
              <div className="flex items-center gap-3 rounded-md bg-background-200/50 px-4 py-3 text-sm text-foreground-400">
                <i className="ri-time-line text-lg text-accent-500"></i>
                工作日 09:00 - 18:00 内回复
              </div>
            </div>
          </section>

          <section className="rounded-lg border border-background-200/60 bg-background-100/40 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">
              <Link to="/about" className="hover:text-accent-500 cursor-pointer">免责声明</Link>
            </h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-400">
              <p>
                本站为<span className="text-foreground-700">产品演示站点</span>，页面中出现的所有影视作品、综艺节目、资讯内容及相关图片，均为用于展示界面的示意性演示数据。
              </p>
              <p>
                站内的“播放”功能仅用于界面演示，<span className="text-foreground-700">不接入任何真实播放接口</span>，也不会实际播放视频内容。
              </p>
              <p>
                用户如对内容存在疑问，可通过上方邮箱与我们联系，我们会及时核实并处理。
              </p>
            </div>
          </section>
        </div>

        <section className="mt-14 rounded-lg border border-background-200/60 bg-background-100/40 p-6 text-center md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">
            <Link to="/about" className="hover:text-accent-500 cursor-pointer">版权声明</Link>
          </h2>
          <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-foreground-400">
            © {new Date().getFullYear()} 榴莲视频 Durian Video. 保留所有权利。本站所有原创文字、视觉与界面设计版权归榴莲视频所有，
            未经许可不得用于商业用途。演示数据中的作品名称、人物与情节均为虚构，如有雷同纯属巧合。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 rounded-md border border-background-300/70 px-6 py-2.5 text-sm text-foreground-500 transition-colors hover:border-primary-400 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-2 rounded-md bg-accent-500 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-accent-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              去搜索影视
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}